import React from "react";
import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe } from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";
import Title from "../layouts/Title";
import Card from "./Card";

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="WEB DEVELOPMENT"
          des="you get a professionally designed website that can be customized according to your requirements. We ensure that your website puts you on top of your competitors."
        />

        <Card
          title="DIGITAL MARKETING"
          des="As a digital marketing agency, we position our clients to become influencers through social media marketing."
          icon={<SiProgress />}
        />

        <Card
          title="Graphics Design"
          des="Our creativity is driven by market and consumer insights, producing designs that works. Not only that, we also work closely with our clients to produce something they are happy with."
          icon={<SiAntdesign />}
        />
        <Card
          title="Hosting Websites"
          des="We provide web hosting service and domain name registration, our hosting package include share and dedicated solutions."
          icon={<FaGlobe />}
        />
        <Card
          title="DIGITAL MARKETING"
          des="As a digital marketing agency, we position our clients to become influencers through social media marketing."
          icon={<SiProgress />}
        />
        <Card
          title="WEB DEVELOPMENT"
          des="you get a professionally designed website that can be customized according to your requirements. We ensure that your website puts you on top of your competitors."
        />
      </div>
    </section>
  );
};

export default Features;
